angular
  .module('common.directives')
  .directive('deviceUiSettingsEdit', function () {
    return {
      scope: {
        uiSettings: '=',
        selectedBulkDevices: '=',
        isBulkDevicesSelected: '=',
        version: '=',
        editConfig: '=',
        onSubmit: '&',
        onCancel: '&',
        isOrgDeviceSettings: '=',
        onShowPrivacyModeForm: '&',
        imei: '=',
        serialNumber: '='
      },
      templateUrl:
        './templates/device-ui-settings-edit.view.html?t=' + window.webpackHash,
      link: function ($scope, $element) {},
      controller: 'DeviceUiSettingsEditController'
    }
  })
